import { Icon, Paragraph } from "@sicredi/react";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

type TextProductDetailProps = {
  text?: string;
  children?: ReactNode;
};

export function TextProductDetail({ children }: TextProductDetailProps) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <Icon name="feedback-success" appearance="primary" />
      </div>

      <Paragraph size="small" weight="normal">
        {children}
      </Paragraph>
    </div>
  );
}
